import { render, staticRenderFns } from "./bins.vue?vue&type=template&id=0d9bf350&"
import script from "./bins.vue?vue&type=script&lang=js&"
export * from "./bins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports